<template>
  <div v-if="loadSuccess == 'Public_Pass'" class="app-container-white">
    <div v-if="user == true">
      <PublicPage/>
      <FooterSIC lineColor="black"/>
    </div>
    <div v-else>
      <VerifyURL status="NullData"/>
      <FooterSIC lineColor="black"/>
    </div>
  </div>
  <div v-else-if="loadSuccess == 'Public_Fail'" class="app-container-white">
    <div v-if="user == true">
      <PublicPage/>
      <FooterSIC lineColor="blackNull"/>
    </div>
    <div v-else>
      <VerifyURL status="NullPublicData"/>
      <FooterSIC lineColor="blackNull"/>
    </div>
  </div>
  <div v-else class="app-container-blue"> 
    <div v-if="loadSuccess == 'Try_Again'">
      <div class="app-container-content">
        <VerifyURL status="Try_Again"/>
      </div>
      <FooterSIC lineColor="whiteExt"/>
    </div>
    <div v-else>
      <div class="app-container-content">
        <div v-if="loadSuccess == 'Login'">
          <LoginSetup authen="login"/>
          <VerifyURL status="login"/>
        </div>
        <div v-else-if="loadSuccess == 'Signup'">
          <LoginSetup authen="signup"/>
          <VerifyURL status="signup"/>
        </div>
        <div v-else-if="loadSuccess == 'Profile'">
          <RegisterProfile/>
          <VerifyURL status="Profile"/>
        </div>
        <div v-else-if="loadSuccess == 'Ready'">
          <VerifyURL status="Ready"/>
        </div>
        <div v-else-if="loadSuccess == 'Owned'">
          <VerifyURL status="Owned"/>
        </div>
        <div v-else-if="loadSuccess == 'Save'">
          <VerifyURL status="Save"/>
        </div>
        <div v-else-if="loadSuccess == 'LoginSucess'">
          <VerifyURL status="LoginSucess"/>
        </div>
        <div v-else-if="loadSuccess == 'ReadUser'">
          <VerifyURL status="ReadUser"/>
        </div>
        <div v-else-if="loadSuccess == 'CheckOwner'">
          <VerifyURL status="CheckOwner"/>
        </div>
        <div v-else-if="loadSuccess == 'Waiting'">
          <VerifyURL status="Waiting"/>
        </div>
        <div v-else>
          <VerifyURL status="Verify"/>
        </div>
      </div>
      <FooterSIC lineColor="white"/>
    </div>
  </div>
</template>

<script>
import LoginSetup from './components/LoginSetup.vue'
import VerifyURL from './components/VerifyURL.vue';
import RegisterProfile from './components/RegisterProfile.vue';
import PublicPage from './components/PublicPage.vue';
import FooterSIC from './components/FooterSIC.vue'
import store from './store';
import actions from './store/user/actions.js'
import auths from './store/auth/auths.js';

var DEBUG = false;
// ENABLE/DISABLE Console Logs
if(!DEBUG){
  console.log = function() {}
}

export default {
  name: 'App',
  store,
  components: {
    LoginSetup,
    VerifyURL,
    RegisterProfile,
    PublicPage,
    FooterSIC,
  },
  title: "SIC Name Card",
  data() {
    return {
      account: null,
      verifyResult: '',
      loadSuccess: '',
      verifyNT: '',
      cipherText: '',
      user: false,
    }
  },
  async created() {
    this.$emitter.on('login',
      async function (account) {
        this.account = account;
      }.bind(this),
    ),
    this.$emitter.on('savecard', async() => {
      this.loadSuccess = "Save"
      await this.saveUserProfile();
    }); 
    this.$emitter.on('profile', async(account) => {
      this.account = account;
      await this.verifyOwner();
    });
    this.$emitter.on('loginSuccess', async(account) => {
      console.log("loginSuccess");
      this.loadSuccess = "LoginSucess";
      this.account = account;
      auths.myMSAL.setActiveAccount(account);
      await this.verifyOwner();
    });
    this.$emitter.on('logout', () => {
      console.log("logOut");
      this.loadSuccess = "Login";
      this.account = undefined;
    });
    this.$emitter.on('savecard', async() => {
      this.loadSuccess = "Save"
      await this.saveUserProfile();
    }); 
    this.$emitter.on('editProfile', async() => {
      await this.checkLoginStatus();
    }); 
    this.$emitter.on('countdown', () => {
      this.loadSuccess = "Waiting";
    }); 
  },
  async beforeMount(){
    this.checkUrl();
  },
  methods: {
    async checkUrl() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      this.cipherText = urlParams.get("cpt");
      console.log("Hello");
        
      if(this.cipherText != null)
      {
        await this.checkVerifyResult();
      }
    },
    async checkVerifyResult() {
      console.log("checkVerifyResult");
      this.verifyNT = await this.verify_nt_parameter();
      this.verifyResult = this.verifyNT;
      if(this.verifyNT == "Login") {
        this.loadSuccess = "Signup";
      }
      else
      {
        this.loadSuccess = this.verifyResult;
      }
    },
    async verify_nt_parameter() {
      console.log("verify_nt_parameter");
      var status_nt = '';
      var response = await actions.checkUser(this.cipherText);
      console.log(response);

      if((response != undefined) || (response != null))
      {
        if (response.ok) {
          status_nt = actions.checkUserResult.status;
          console.log(status_nt);
          if(status_nt == "Public_Fail")
          {
            if(actions.checkUserResult.user == null)
            {
              this.user = false;
            } 
            else
            {
              this.user = true;
            }
          }
          else if(status_nt == "Public_Pass")
          {
            if(actions.checkUserResult.user == null)
            {
              this.user = false;
            } 
            else
            {
              this.user = true;
            }
          }
          else if(status_nt == "Try_Again")
          {
            actions.actionErrorMessage = "Rolling code verification failed."
          }
          else if(status_nt == "Input Data is incorrect!")
          {
            actions.actionErrorMessage = "The input rolling code is incorrect."
            status_nt = "Try_Again";
          }
        }
        else
        {
          status_nt = "Try_Again";
          localStorage.clear();
        }
        // status_nt = "Login"
      }
      else
      {
        status_nt = "Try_Again";
        localStorage.clear();
      }
      
      return status_nt;
    },
    async verifyOwner() {
      console.log("verifyOwner");
      if((this.$store.state.accessToken == '') || (this.$store.state.accessToken == null)){
        await actions.getAccessToken(auths.myMSALConfig);
      }

      if(actions.checkaccessTokenStatus == true)
      {
        this.$store.commit('setAccessToken',actions.accessTokenResponse);
        this.loadSuccess = "CheckOwner";

        let token = this.$store.state.accessToken;
        var response = await actions.checkOwner(token, this.cipherText);

        if((response != undefined) || (response != null))
        {
          if (response.ok) {
            var result = actions.checkOwnerResult;
            if(result.status != "Success")
            {
              this.loadSuccess = "Owned";
            }
            else
            {
              await this.verifyUser();
            }
          }
          else
          {
            this.loadSuccess = "Try_Again";
            localStorage.clear();
          }
        }
        else
        {
          this.loadSuccess = "Try_Again";
          localStorage.clear();
        }
      }
      else
      {
        localStorage.clear();
        this.loadSuccess = "Login";
      }
    },
    async verifyUser()
    {
      console.log("verifyUser");
      if((this.$store.state.accessToken == '') || (this.$store.state.accessToken == null)){
        await actions.getAccessToken(auths.myMSALConfig);
      }

      if(actions.checkaccessTokenStatus == true)
      {
        this.$store.commit('setAccessToken',actions.accessTokenResponse);
        this.loadSuccess = "ReadUser";

        let token = this.$store.state.accessToken;
        var response = await actions.readUser(token, this.cipherText);
        console.log(response);

        if((response != undefined) || (response != null))
        {
          if (response.ok) {
            var result = actions.initialUserResult;
            if(result.status != 'Success')
            {
              this.loadSuccess = "Try_Again";
              localStorage.clear();
            }
            else
            {
              this.loadSuccess = "Profile"
            }
          }
          else
          {
            this.loadSuccess = "Try_Again";
            localStorage.clear();
          }
        }
        else
        {
          this.loadSuccess = "Try_Again";
          localStorage.clear();
        }
      }
      else
      {
        localStorage.clear();
        this.loadSuccess = "Login";
      }
    },
    async checkLoginStatus() {
      console.log("checkLoginStatus");
      const accounts = auths.myMSAL.getAllAccounts();
      console.log(accounts);
      if (accounts.length > 0)
      {
        this.account = accounts[0];
        await this.verifyOwner();
        this.verifyResult = this.loadSuccess;
      }
      else
      {
        this.verifyResult = "Login";
      }
      this.loadSuccess = this.verifyResult;
    },
    async saveUserProfile() {
      console.log("saveProfile");
      if((this.$store.state.accessToken == '') || (this.$store.state.accessToken == null)){
        await actions.getAccessToken(auths.myMSALConfig);
        this.$store.commit('setAccessToken',actions.accessTokenResponse);
      }

      if(actions.checkaccessTokenStatus == true)
      {
        this.$store.commit('setAccessToken',actions.accessTokenResponse);
        let token = this.$store.state.accessToken;
        var response = await actions.saveProfile(token);
        
        if((response != undefined) || (response != null))
        {
          if(response == true)
          {
            this.loadSuccess = "Ready"
          }
          else
          {
            this.loadSuccess = "Try_Again";
            localStorage.clear();
          }
        }
        else
        {
          this.loadSuccess = "Try_Again";
          localStorage.clear();
        }
      }
      else
      {
        this.loadSuccess = "Try_Again";
        localStorage.clear();
      }
    },
  }
  
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Inter');
html, body {
  height: 100%;
  max-width: 100%;
  margin: 0;
  padding: 0;
  font-family: 'inter';
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
}
.app-container-blue {
  position: relative;
  min-height: 100vh;
  background-color: #051c44;
}
.app-container-content{
  position: relative;
  min-height: 95vh;
}
.app-container-white {
  position: relative;
  min-height: 100vh;
  background-color: white;
}

@media screen and (min-width: 660px) {
  .app-container-content{
    min-height: 93vh;
  }
}
@media screen and (max-height: 390px) {
  .app-container-content{
    min-height: 91vh;
  }
}
</style>
